window.mixinAxios = {
	data: () => ({
		// multiple requests at a time (new way of doing things)
		nrRequestsActive: 0,

		// single request at a time (backwards compatibility)
		requestActive: false,
	}),
	created: function () {
	},
	methods: {
		mixinAxios: function (funcPreRequest = null, funcPostRequest = null) {
			var createAxiosClient = (funcPreRequest = null, funcPostRequest = null) => {
				var preAndPost = (typeof funcPreRequest === 'function') && (typeof funcPostRequest === 'function');
				var axiosClient = axios.create();

				axiosClient.interceptors.request.use((config) => {
					if (preAndPost) {
						funcPreRequest();
					} else {
						this.nrRequestsActive++;
						this.requestActive = true;
					}
					return config;
				}, (error) => {
					if (preAndPost) {
						funcPreRequest();
					} else {
						this.nrRequestsActive++;
						this.requestActive = true;
					}
					return Promise.reject(error);
				});

				axiosClient.interceptors.response.use((response) => {
					if (preAndPost) {
						funcPostRequest();
					} else {
						this.nrRequestsActive--;
						this.requestActive = false;
					}
					return response;
				}, (error) => {
					if (preAndPost) {
						funcPostRequest();
					} else {
						this.nrRequestsActive--;
						this.requestActive = false;
					}
					return Promise.reject(error);
				});

				return axiosClient;
			};

			return createAxiosClient(funcPreRequest, funcPostRequest);
		}
	},
	computed: {
		requestsActive() {
			return (this.nrRequestsActive > 0);
		}
	}
};